import { createSlice } from "@reduxjs/toolkit";

const lockRoutesSlice = createSlice({
  name: "lockRoutes",
  initialState: { isLockRoutesMode: false },
  reducers: {
    toggleLockRoutesMode(state) {
      state.isLockRoutesMode = !state.isLockRoutesMode;
    },
  },
});

export const { toggleLockRoutesMode } = lockRoutesSlice.actions;
export default lockRoutesSlice.reducer;
